export class GlideType {
    ID?: number;
    Name?: string;
}

export default GlideType;